var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasActiveFilters)?_c('div',{staticClass:"active-filters"},[_c('div',{staticClass:"active-filters__container"},_vm._l((_vm.allActiveFilters),function(filter){return _c('filter-pill',{key:`${filter.type}-${filter.value}`,attrs:{"value":filter.value,"label":filter.label,"type":filter.type},on:{"remove":_vm.handleFilterRemove}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }